var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpIco6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emp-ico-6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.656,
    height: 15.656,
    viewBox: "0 0 15.656 15.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3665",
    "data-name": "Path 3665",
    d: "M0,0H15.656V15.656H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3666",
    "data-name": "Path 3666",
    d: "M8.262,12.262H5A3.262,3.262,0,1,0,8.262,9,3.262,3.262,0,0,0,5,12.262",
    transform: "translate(-1.738 -3.129)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3667",
    "data-name": "Path 3667",
    d: "M17.123,5,13.6,8.523",
    transform: "translate(-4.728 -1.738)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3668",
    "data-name": "Path 3668",
    d: "M17.262,5H14",
    transform: "translate(-4.867 -1.738)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3669",
    "data-name": "Path 3669",
    d: "M19,5V8.262",
    transform: "translate(-6.605 -1.738)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpIco6);
export default __webpack_public_path__ + "static/media/emp-ico-6.7ce1ab1c2ef0f4470cfaa60e5e974b01.svg";
export { ForwardRef as ReactComponent };